module.exports = __webpack_public_path__ + "img/fun07.8a8172a2.png";